(function($){
    const defaults = $.fn.datepicker.defaults;

    //defaults.format = 'dd-mm-yyyy';
    defaults.format = document.location.pathname.startsWith('/admin/') ? 'yyyy-mm-dd' : 'dd.mm.yyyy';
    defaults.todayHighlight = true;
    defaults.autoclose = true;
    defaults.language = 'ru'; // todo: implement by config locale

    $.fn.datepicker.dates['ru'] = {
        days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
        daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб"],
        daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
        today: "Сегодня",
        clear: "Очистить",
        weekStart: 1,
        monthsTitle: 'Месяцы'
    };
}(jQuery));
